import React, { Component, useState} from 'react';
import {connect} from 'react-redux'
import CategorysList from './CategorysList'
import { Link, Redirect } from "react-router-dom";
import {addOptionQueryParam} from '../../redux/actions'
import CategoryAlbum from './CategoryAlbum'

// TODO: Just for testing! data should be recived from data base
const categorys =  [
    {
      img:"https://cnet4.cbsistatic.com/img/iJxo9AIxiXHqVoqm6nGISKtKwPI=/2020/08/18/b7168aea-9f7e-47bb-9f31-4cb8ad92fbc7/lg-note-20-ultra-5g-iphone-11-se-google-pixel-4a-lg-velvet-6133.jpg",
      name:"phones",
      defTree:1,
    },
]


const HomeScreenV2 = () => {

  const [reduirctPath, setRereduirctPath] = useState("");
  const [reduirct, setRereduirct] = useState(false);
  if(reduirct && (reduirctPath !== "")){
    return <Redirect to={reduirctPath}/>;
  }
  return (
    <div className={"home-screen-v-2"}>
      <main>
          <p class="centered page-title">
            {"Im Looking for "}
            <div className="select-wraper">
            <select onChange={(e)=>setRereduirctPath(e.target.value)}>
              <option>   </option>
              <option value={"/choose?category=phones&treeId=1&ordering=-score"}> Phones </option>
            </select>
            </div>
            <button disabled={!reduirctPath} onClick={()=>setRereduirct(true)}>
              {"GO"}
            </button>
          </p>
      </main>
    </div>
  )
}

const mapStateToProps = (state) => ({
})

const actionsCreators = {
  addOptionQueryParam:addOptionQueryParam
}
export default connect(mapStateToProps, actionsCreators)(HomeScreenV2)
